import {createFeature, createReducer, on} from '@ngrx/store';
import {FeatureStoreNames} from '@shared-types';

import {formGroupActions} from './form-group.actions';
import {formGroupAdapter, FormGroupStore} from './form-group.models';

import IFormGroupsState = FormGroupStore.IFormGroupsState;

const formGroupFeature = createFeature({
	name: FeatureStoreNames.FORM_GROUP_FEATURE_KEY,
	reducer: createReducer(
		{...FormGroupStore.formGroupInitialState},
		on(formGroupActions.getFormGroupsList, state => ({...state, error: undefined, loading: true})),
		on(formGroupActions.getFormGroupsListSuccess, (state, {formGroups}) => {
			//rebase state with new data
			const newState = formGroupAdapter.setAll(formGroups, state);
			return {...newState, error: undefined, loading: false, loaded: true};
		}),
		on(formGroupActions.getFormGroupsListFailure, (state, {error}) => ({...state, error: error, loading: false, loaded: false})),
	),
});

export function formGroupReducer(state: IFormGroupsState | undefined, action: any): IFormGroupsState {
	return formGroupFeature.reducer(state, action);
}
